import { get, set } from '@atlassian/help-center-common-util/history-qs';

export const getSidebarExperienceName = () => {
    return get('experience');
};

export const clearSidebarExperienceAndCustomize = () => {
    set({ customize: undefined, experience: undefined });
};
